<template>
  <div class="ivr TopHeadder">
      <!-- 智能ivr -->
      <div class="bannerBox">
          <img src="../../assets/image/yi_banner.jpg" />
           <div class="bannerTitle">
             <h3>电话外呼系统--易营销</h3>
             <p>助你快速低成本拥有专业的电销运营中心</p>
             <p class="ti_te">· 即 开 即 用 · 弹 性 扩 容 · 稳 定 性 高 · 成 本 低</p>
          </div>
      </div>
      <div class="PublicPadding Y_item">
          <h4 class="title">易营销系统简述</h4>
          <div>
             <i><img src="../../assets/image/yi_1.jpg"/></i>
             <p>易营销是小语智能凭借15年呼叫系统技术研发经验，打造的企业级电话外呼营销系统平台。易营销包含了传统呼叫中心的电话交换、IVR、录音、CTI等所有软件模块，为中小企业提供高效的电话营销服务，快速筛选客户线 索，挖掘有价值的意向客户。解决企业营销过程中工作效率低下，客户跟进不及时、销售团队管理难等问题，助力企业营销快速提升，以低成本带来高业绩。</p>
          </div>
      </div>
      <div class="PublicPadding pubitem">
          <h4 class="title">主要功能</h4>
          <ul>
             <li>
               <i>
                 <img src="../../assets/image/yyx_1.png"/>
               </i>
               <p>批量导入</p>
             </li>
             <li>
               <i>
                 <img src="../../assets/image/yyx_2.png"/>
               </i>
               <p>自动外呼</p>
             </li>
             <li>
               <i>
                 <img src="../../assets/image/yyx_3.png"/>
               </i>
               <p>电话弹屏</p>
             </li>
             <li>
               <i>
                 <img src="../../assets/image/yyx_4.png"/>
               </i>
               <p>自动录音</p>
             </li>
             <li>
               <i>
                 <img src="../../assets/image/yyx_5.png"/>
               </i>
               <p>通话记录</p>
             </li>
             <li>
               <i>
                 <img src="../../assets/image/yyx_6.png"/>
               </i>
               <p>客户管理</p>
             </li>
             
             <li>
               <i>
                 <img src="../../assets/image/yyx_7.png"/>
               </i>
               <p>黑名单</p>
             </li>
             <li>
               <i>
                 <img src="../../assets/image/yyx_8.png"/>
               </i>
               <p>挂机短信</p>
             </li>
             <li>
               <i>
                 <img src="../../assets/image/yyx_9.png"/>
               </i>
               <p>坐席管理</p>
             </li>
             <li>
               <i>
                 <img src="../../assets/image/yyx_10.png"/>
               </i>
               <p>统计报表</p>
             </li>
          </ul>
      </div>
            <div class="PublicPadding mTop20">
          <ul class="ulType1">
              <li>
                  <p class="li_tit">高效智能</br>成倍提升销售效率</p> 
                   <img src="../../assets/image/y3_1.jpg" class="li_pic">
                  <p class="li_txt">
                     客户批量导入：批量导入客户资料，有效过滤重号、错号，提升工作效率。</br>
                     自动外呼：系统自动外呼，节省人工拨号等待时间，自动识别通话状态，将有效电话转接给合适的坐席，提升外呼效率。
                  </p>
              </li>
              <li>
                  <p class="li_tit">客户跟进</br>随时穿透销售进度</p>
                  <img src="../../assets/image/y3_2.jpg" class="li_pic">
                  <p class="li_txt">
                     电话弹屏：电话转接坐席时，自动弹出客户通话信息。</br>
                     客户跟进：详尽记录客户沟通 跟进情况及联系线索，客户跟进动态随时掌握。</br>
                     通话录音：通话过程自动录音，有效质检销售工作态度。
                  </p>
              </li>
              <li>
                  <p class="li_tit">稳定客源</br>降低客户流失率</p>
                  <img src="../../assets/image/y3_3.jpg" class="li_pic">
                  <p class="li_txt">完善的CRM客户管理模块，全面掌握客户信息、跟进动态，有效积累客户资源，防止因销售人员流动造成的客户资源流失和服务中断。</p>
              </li>
              <li>
                  <p class="li_tit">多维度数据报表</br>透明管理营销团队</p>
                  <img src="../../assets/image/y3_4.jpg" class="li_pic">
                  <p class="li_txt">提供多维度的数据报表，包括话务情况统计、坐席工作统计、任务信息统计、电话呼损统计等，有效管理销售团队。</p>
              </li>
              <li>
                  <p class="li_tit">AI语音机器人无缝对接</br>企业营销更智能</p>
                  <img src="../../assets/image/y3_5.jpg" class="li_pic">
                  <p class="li_txt">提供机器人接口，实现与AI语音机器人的无缝对接，企业可将机械重复的外呼任务交给AI机器人辅助完成，重构智能化外呼生态模式。</p>
              </li>
              <li>
                  <p class="li_tit">从线路到实施</br>让企业无后顾之忧</p>
                  <img src="../../assets/image/y3_6.jpg" class="li_pic">
                  <p class="li_txt">采用成熟的软件Saas模式，上线时间更短，成本更低。</br>
                      易营销可为客户提供优质线路规划与落地，真正让中小企业在外呼营销上没有后顾之忧。</p>
              </li>
          </ul>
      </div>
     <!-- <div class="PublicPadding">
          <h4 class="title">功能介绍</h4>
          <div class="PublicUl">
              <ul class="clear PublicStyle">
                  <li>
                      <i><img src="../../assets/image/home_yuyin.png" /></i>
                      <h6>自动语音应答</h6>
                      <p>自动语音提示或选择按键完成交互体验</p> 
                  </li>
                  <li>
                      <i><img src="../../assets/image/home_luyou.png" /></i>
                      <h6>智能路由分配</h6>
                      <p>多种智能路由功能，可将用户话务直接路由到相应的IVR节点</p> 
                  </li>
                  <li>
                      <i><img src="../../assets/image/home_xinxiang.png" /></i>
                      <h6>短信/语音信箱</h6>
                      <p>支持接入消息服务，向客户推送业务短信；支持IVR语音留言</p> 
                  </li>
                  <li>
                      <i><img src="../../assets/image/home_data.png" /></i>
                      <h6>数据分析</h6>
                      <p>统计业务通话中各项信息，为优化服务流程提供数据支持</p> 
                  </li>
              </ul>
          </div>
      </div>

      <div class="PublicPadding mTop20">
          <h4 class="title">应用场景</h4>
          <ul class="ulType3">
              <li>
                  <img src="../../assets/image/ivr_scene_pic1.jpg" class="li_pic">
                  <p class="li_tit">银行场景应用</p>
                  <p class="li_txt">求改密码、余额查询、手机号绑定、账户提额、基础信息查询等</p>
              </li>
              <li>
                  <img src="../../assets/image/ivr_scene_pic2.jpg" class="li_pic">
                  <p class="li_tit">快递场景应用</p>
                  <p class="li_txt">信息咨询、装运跟踪、到货日期查询、到货地点查询等</p>
              </li>
              <li>
                  <img src="../../assets/image/ivr_scene_pic3.jpg" class="li_pic">
                  <p class="li_tit">航空场景应用</p>
                  <p class="li_txt">票务信息、预定机票座位确认、获取航线通知、航班时间查询、货运监督等</p>
              </li>
              <li>
                  <img src="../../assets/image/ivr_scene_pic4.jpg" class="li_pic">
                  <p class="li_tit">保险场景应用</p>
                  <p class="li_txt">投保信息查询、赔付信息查询、受益人信息查询、ID卡申请、保单申请、健康咨询等</p>
              </li>
              <li>
                  <img src="../../assets/image/ivr_scene_pic5.jpg" class="li_pic">
                  <p class="li_tit">证券场景应用</p>
                  <p class="li_txt">股票交易电话委托、估值查询、新股查询、个股点评、最新行情通知等</p>
              </li>
              <li>
                  <img src="../../assets/image/ivr_scene_pic6.jpg" class="li_pic">
                  <p class="li_tit">旅游场景应用</p>
                  <p class="li_txt">自主选择旅游路线、日期、人数、房间数，自主预约</p>
              </li>
          </ul>
      </div>-->
      <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'ivr',
  data () {
    return {
      
    }
  },
  components:{
     Popup
  },
   methods:{
      popup(){
       this.$store.commit("openPop",{isopen:true,type:1})
      },
  
  }
}
</script>


<style scoped>
.bannerTitle{
   left:0.34rem;
}
.bannerTitle h3{
    text-align:left;
}
.bannerTitle p{
    text-align:left;
}
.bannerTitle p.ti_te{
    font-size:0.2rem;
}
.Y_item i{
  display:block;
  width:5.1rem;
  height:3.32rem;
  margin:0 auto;
  margin-top:0.2rem;
  margin-bottom:0.2rem;
}
.Y_item i img{
  display:block;
  width:5.1rem;
  height:3.32rem;
}
.Y_item p{
    font-size:0.2rem;
    color:#666;
    padding:0 0.3rem;
    line-height:0.4rem;
}
.ulType1 li .li_pic{
    width:5.19rem;
    height:3.41rem;
}
</style>



// WEBPACK FOOTER //
// src/components/product/IVR.vue